import { GetNotifications } from "../../Services/MainServices";

export const GET_NOTIFICATIONS_REQUEST = "GET_NOTIFICATIONS_REQUEST";
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
export const GET_NOTIFICATIONS_FAILURE = "GET_NOTIFICATIONS_FAILURE";

const getPageNumberFromUrl = (url) => {
  if (!url) return null;
  const match = url.match(/page=(\d+)/);
  return match ? parseInt(match[1], 10) : null;
};

const getCurrentPage = (next, previous) => {
  const nextPage = getPageNumberFromUrl(next);
  const prevPage = getPageNumberFromUrl(previous);

  if (prevPage !== null) return prevPage + 1;
  if (nextPage !== null) return nextPage - 1;
  return 1; // fallback
};

export const getNotifications = async (
  dispatch,
  page = 1,
  isLoadMore = false
) => {
  dispatch({ type: GET_NOTIFICATIONS_REQUEST });
  try {
    const response = await GetNotifications(page);
    if (response.status === 200) {
      const data = response.data;
      const notifications = data.results.notifications;
      const count = data.count;
      const unreadCount = data.results.unread_count;

      const next = data.next;
      const previous = data.previous;

      const pageSize = notifications.length;
      const totalPages = Math.ceil(count / pageSize);
      const currentPage = next
        ? next.split("=")[1] - 1
        : previous.split("=")[1] ?? 2;

      dispatch({
        type: GET_NOTIFICATIONS_SUCCESS,
        payload: {
          notifications,
          currentPage,
          totalPages,
          isLoadMore,
          unreadCount,
          next,
          previous,
        },
      });
    } else {
      throw new Error("Failed to get notifications");
    }
  } catch (error) {
    dispatch({ type: GET_NOTIFICATIONS_FAILURE, error });
  }
};
